// This file is auto-generated by @hey-api/openapi-ts
import type {
  DeleteCommentsByIdUnlikeResponse,
  DeletePostsByIdUnlikeResponse,
  GetClubsByIdFeedResponse,
  GetUsersByIdPostsResponse,
  GetUsersFeedNewsResponse,
  GetUsersFeedPostsResponse,
  GetUsersFeedResponse,
  PostCommentsByIdLikeResponse,
  PostPostsByIdLikeResponse,
  PostPostsResponse,
} from './types.gen';

const postSchemaResponseTransformer = (data: any) => {
  data.comments = data.comments.map((item: any) => commentSchemaResponseTransformer(item));
  return data;
};

const commentSchemaResponseTransformer = (data: any) => {
  if (data.children) {
    data.children = data.children.map((item: any) => commentSchemaResponseTransformer(item));
  }
  return data;
};

export const getClubsByIdFeedResponseTransformer = async (data: any): Promise<GetClubsByIdFeedResponse> => {
  if (data.feed) {
    data.feed = data.feed.map((item: any) => postSchemaResponseTransformer(item));
  }
  return data;
};

export const postCommentsByIdLikeResponseTransformer = async (data: any): Promise<PostCommentsByIdLikeResponse> => {
  data.comment = commentSchemaResponseTransformer(data.comment);
  return data;
};

export const deleteCommentsByIdUnlikeResponseTransformer = async (
  data: any,
): Promise<DeleteCommentsByIdUnlikeResponse> => {
  if (data.comment) {
    data.comment = commentSchemaResponseTransformer(data.comment);
  }
  return data;
};

export const postPostsByIdLikeResponseTransformer = async (data: any): Promise<PostPostsByIdLikeResponse> => {
  if (data.post) {
    data.post = postSchemaResponseTransformer(data.post);
  }
  return data;
};

export const deletePostsByIdUnlikeResponseTransformer = async (data: any): Promise<DeletePostsByIdUnlikeResponse> => {
  if (data.post) {
    data.post = postSchemaResponseTransformer(data.post);
  }
  return data;
};

export const postPostsResponseTransformer = async (data: any): Promise<PostPostsResponse> => {
  if (data.post) {
    data.post = postSchemaResponseTransformer(data.post);
  }
  return data;
};

export const getUsersByIdPostsResponseTransformer = async (data: any): Promise<GetUsersByIdPostsResponse> => {
  if (data.posts) {
    data.posts = data.posts.map((item: any) => postSchemaResponseTransformer(item));
  }
  return data;
};

export const getUsersFeedResponseTransformer = async (data: any): Promise<GetUsersFeedResponse> => {
  if (data.posts) {
    data.posts = data.posts.map((item: any) => postSchemaResponseTransformer(item));
  }
  return data;
};

export const getUsersFeedPostsResponseTransformer = async (data: any): Promise<GetUsersFeedPostsResponse> => {
  if (data.posts) {
    data.posts = data.posts.map((item: any) => postSchemaResponseTransformer(item));
  }
  return data;
};

export const getUsersFeedNewsResponseTransformer = async (data: any): Promise<GetUsersFeedNewsResponse> => {
  if (data.posts) {
    data.posts = data.posts.map((item: any) => postSchemaResponseTransformer(item));
  }
  return data;
};
